import addressDetails from './addressDetails';
import details from './details';
import obfuscation from './obfuscation';
import historyVisibilityBasedOnPersonalData from './historyVisibilityBasedOnPersonalData';
import nameAndLastnameChange from './nameAndLastnameChange';
import onSecondCoownerLastNameChange from './onSecondCoownerLastNameChange';
import onSecondCoownerNameChange from './onSecondCoownerNameChange';

export const secondCoowner = {
  ...addressDetails,
  ...details,
  ...obfuscation,
  ...historyVisibilityBasedOnPersonalData,
  ...nameAndLastnameChange,
  ...onSecondCoownerLastNameChange,
  ...onSecondCoownerNameChange,
};
